/**
 * Breakpoint values for styled-components and react-responsive.
 * Must stay in sync with `--breakpoint-lg` in src/ui-kit/tailwind.css.
 */
export const size = {
  tablet: '992px',
} as const;

export const device = {
  tablet: `min-width: ${size.tablet}`,
} as const;
